import { ImageCrop, FocalPoint, ImageWithCrops } from '@/services/platform/api/model';
import { getConfig } from '../../../../config/environment';

export interface Image {
  src?: string;
  alt?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  extension?: string | undefined;
  type?: string | null;
}

export const ImageMap = (
  source?: ImageWithCrops | null,
  cropAlias?: string | null,
  crop?: ImageCrop | null
): Image | undefined => {
  if (!source) return undefined;
  return {
    src: getImageUrl(source, crop, undefined, cropAlias),
    alt:
      (source?.properties?.['caption'] as string) ||
      source?.name?.replace(`.${source.extension}`, '') ||
      undefined,
    width: source.width || undefined,
    height: source.height || undefined,
    extension: source.extension || undefined,
    type: source.mediaType || null,
  };
};

export const ImagesToImageMap = (
  source?: ImageWithCrops[] | null,
  cropAlias?: string | null,
  crop?: ImageCrop | null
): Image | undefined => {
  if (source == null || source.length === 0 || source === undefined) {
    return undefined;
  }

  const links = source.map(item => ImageMap(item, cropAlias, crop));

  return links[0] || undefined;
};

export const ImagesToImageMapOriginal = (source?: ImageWithCrops[] | null): ImageWithCrops | undefined => {
  if (!source || source.length === 0) return undefined;
  return source[0];
};

export const ImagesToImagesMap = (
  source?: ImageWithCrops[] | null,
  cropAlias?: string | null,
  crop?: ImageCrop | null
): Image[] => {
  if (source == null || source.length === 0 || source === undefined) {
    return [];
  }

  const links = source.map(item => ImageMap(item, cropAlias, crop)).filter(item => item !== undefined);

  return links || [];
};

export const getImageUrl = (
  source?: ImageWithCrops | null,
  crop?: ImageCrop | null,
  focalPoint?: FocalPoint | null,
  cropAlias?: string | null
): string => {
  if (!source) return '';

  const config = getConfig();
  const urlParams: string[] = [];

  if (cropAlias && (source as ImageWithCrops) && 'crops' in source) {
    crop = (source as ImageWithCrops).crops?.find(c => c.alias === cropAlias);
    focalPoint = (source as ImageWithCrops)?.focalPoint;
  }

  let imageUrl =
    (source.url ? (source.url.startsWith('http') ? source?.url : `${config.mediaUrl}${source?.url}`) : '') ||
    '';

  // If the crop has coordinates, use them
  if (crop?.coordinates) {
    const { x1, y1, x2, y2 } = crop.coordinates;
    urlParams.push(`cc=${x1},${y1},${x2},${y2}`);
  }

  if (focalPoint) {
    // Fallback to focal point cropping
    const focalPointValue = focalPoint !== null ? `${focalPoint.left},${focalPoint.top}` : '0.5,0.5';
    urlParams.push(`rxy=${focalPointValue}`);
  }

  if (source.mediaType != 'umbracoMediaVideo' && source.mediaType != 'umbracoMediaArticle') {
    if (crop && (crop.width || crop.height)) {
      if (crop.width) urlParams.push(`width=${crop.width}`);
      if (crop.height) urlParams.push(`height=${crop.height}`);
    }

    urlParams.push('mode=crop');
    urlParams.push('quality=90');

    if (urlParams.length > 0) {
      imageUrl = `${imageUrl}?${urlParams.join('&')}`;
    }
  }

  return imageUrl;
};
